import { BaseModel } from './base';

export enum CustomerNoteType {
  note = 0,
  formula = 1,
  alert = 2,
}

export const CustomerNoteTypeLabels: Record<CustomerNoteType, string> = {
  [CustomerNoteType.note]: 'general.note',
  [CustomerNoteType.formula]: 'api.models.customerNote.formula',
  [CustomerNoteType.alert]: 'api.models.customerNote.alert',
};

export class CustomerNote extends BaseModel {
  idCustomerNote!: number;
  type!: CustomerNoteType;
  content!: string;

  override objectID(): string | null {
    return this.idCustomerNote?.toString() ?? null;
  }

  get isTypeNote(): boolean {
    return this.type === CustomerNoteType.note;
  }

  get isTypeFormula(): boolean {
    return this.type === CustomerNoteType.formula;
  }

  get isTypeAlert(): boolean {
    return this.type === CustomerNoteType.alert;
  }
}
